import Button from './button'
import Badge from './badge'
import Card from './card'
import Drawer from './drawer'
import Form from './form'
import FormLabel from './formLabel'
import Heading from './heading'
import Input from './input'
import Menu from './menu'
import Modal from './modal'
import NumberInput from './numberInput'
import Spinner from './spinner'
import Select from './select'
import Table from './table'
import Tabs from './tabs'
import Tag from './tags'
import Text from './text'
import './tooltip'
import './textarea'

const components = {
  Button,
  Badge,
  Card,
  Drawer,
  Form,
  FormLabel,
  Heading,
  Input,
  Menu,
  Modal,
  NumberInput,
  Spinner,
  Select,
  Table,
  Tabs,
  Tag,
  Text,
}

export default components
